module.exports = __webpack_public_path__ + "public/be4ba3dd17008135675e945b630be8f6.woff";